import reduce from './reduce'
import currentRoutes from '../routes'
import containerRoutes from './containers'

const combinedRoutes = _.compact([...(containerRoutes || []), currentRoutes, window.addiesaas.routes || []])
const routes = reduce(combinedRoutes)

export default routes || []
